import React, { useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'

const CartItem = ({ item, onUpdateItem }) => {
  const [quantity, setQuantity] = useState(item.quantity)
  const onQuantityChange = (e) => {
    setQuantity(e.target.value)
    onUpdateItem(item, e.target.value)
  }

  useEffect(() => {
    setQuantity(item.quantity)
  }, [item.quantity])

  return (
    <div className='cart-item'>
      <img src={item.image} alt={item.handle} />
      <div className='item-info'>
        <p>{item.variant_title}</p>
        <p>{item.product_title}</p>
        <div className='price-quantity'>
          <div className='quantity-input'>
            <span>Qty:</span>
            <input type='number' value={quantity} onChange={onQuantityChange} />
          </div>
          <p>${item.price / 100}</p>
        </div>
        <MdClose
          className='btn-delete-item'
          onClick={() => onUpdateItem(item, 0)}
        />
      </div>
    </div>
  )
}

export default CartItem
